import { render, staticRenderFns } from "./formPeriodNew.vue?vue&type=template&id=1f78dbdc&scoped=true&"
import script from "./formPeriodNew.vue?vue&type=script&lang=js&"
export * from "./formPeriodNew.vue?vue&type=script&lang=js&"
import style0 from "./formPeriodNew.vue?vue&type=style&index=0&id=1f78dbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f78dbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f78dbdc')) {
      api.createRecord('1f78dbdc', component.options)
    } else {
      api.reload('1f78dbdc', component.options)
    }
    module.hot.accept("./formPeriodNew.vue?vue&type=template&id=1f78dbdc&scoped=true&", function () {
      api.rerender('1f78dbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formPeriodNew.vue"
export default component.exports